<template>
    <div class="container">
        <common-table :data="tableData" ref="commonTable" :isShow="false">
            <el-table-column type="index" min-width="80" label="序号"></el-table-column>
            <el-table-column prop="ocrType" label="类型" min-width="100" :formatter="formatTranTypee" show-overflow-tooltip></el-table-column>
            <el-table-column prop="result" label="识别结果" min-width="100" :formatter="formatResult" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="识别时间" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" fixed="right" min-width="100">
                <template slot-scope="scope">
                    <el-button type="text" @click="handleDel(scope.row.id)">删除</el-button>
                    <el-button type="text" @click="handleDetail(scope.row.id)">查看</el-button>
                </template>
            </el-table-column>
        </common-table>
        <show-info-dialog ref="showInfoDialog" title="详情">
            <el-image :src="imageUrl" fit="contain" class="showImage flex-row absolute-center"></el-image>
        </show-info-dialog>
    </div>
</template>

<script>
    import CommonTable from 'components/common/CommonTable'
    import TransactionService from 'service/TransactionService'
    import Server from 'common/conf/Server';
    import ocrType from 'service/constant/ocrType'
    import ShowInfoDialog from '@/view/dialog/ShowInfoDialog'
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from 'vuex'
    export default {
        name: "authdata",
        components: {
            CommonTable, ShowInfoDialog
        },
        data(){
            return{
                tableData:[],
                ocrType: ocrType,
                imageUrl:'',
                host: Server[process.env.NODE_ENV] + '8885/ocr/preview/'
            }
        },
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        mounted(){
            this.getList();
        },
        computed: {
            ...mapGetters(['serverType', 'tatId', 'userId'])
        },
        methods:{
            getList() {
                this.doLoad(TransactionService.ocrAuthGetList,{
                    userId: this.$route.params.id,
                }, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        this.tableData = result;
                    });
                }, '信息获取失败')
            },
            doDel(id) {
                this.doLoad(TransactionService.ocrDisable,{
                    id: id,
                }, res => {
                    this.showSuccess(res.respMsg)
                    this.getList();
                }, '信息获取失败')
            },
            handleDel(id){
                this.showConfirm(`确定对此数据进行删除操作？`).then(()=>{
                    this.doDel(id);
                }).catch(()=>{});
            },
            handleDetail(id){
                this.imageUrl = this.host + id;
                this.$refs.showInfoDialog.open();
            },
            formatTranTypee(row, column, cellValue) {
                let value = '';
                value = this.ocrType[cellValue];
                return value ? value : '--';
            },
            formatResult(row, column, cellValue) {
                return cellValue == 'success' ? '识别成功' : '识别失败'
            },
        },
    }
</script>

<style scoped>
    .showImage{
        max-width: 100%;
        min-width: 500px;
        min-height: 500px;
    }
</style>



// WEBPACK FOOTER //
// src/view/fragment/MemberManage/AuthData.vue